import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { PROPS__image_bounds } from './PROPS__image_bounds';

/** Helper: Draws image onto canvas with optional forced aspect ratio */
export function FN_CANVAS__draw_fit_image(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  x: number,
  y: number,
  w: number,
  h: number,
  targetAspect: number = NaN,
  skipDraw: boolean = false,
): PROPS__image_bounds {
  if (img === ENUM__html_ref_stub.IMAGE) {
    return { x: NaN, y: NaN, w: NaN, h: NaN };
  }

  const ar__image: number = !isNaN(targetAspect) ? targetAspect : img.naturalWidth / img.naturalHeight;
  const ar__box: number = w / h;

  let draw_w: number;
  let draw_h: number;

  if (ar__image > ar__box) {
    [draw_w, draw_h] = [w, w / ar__image];
  } else {
    [draw_h, draw_w] = [h, h * ar__image];
  }

  const draw_x: number = x + (w - draw_w) * 0.5;
  const draw_y: number = y + (h - draw_h) * 0.5;

  if (!skipDraw) {
    ctx.drawImage(img, draw_x, draw_y, draw_w, draw_h);
  }

  return { x: draw_x, y: draw_y, w: draw_w, h: draw_h };
}
